import { IContact } from 'app/shared/model/contact.model';
import { IOrganisation } from 'app/shared/model/organisation.model';
import { IDepartment } from 'app/shared/model/department.model';

export interface IEmployee {
  id?: number;
  contact?: IContact | null;
  organisation?: IOrganisation | null;
  department?: IDepartment | null;
}

export const defaultValue: Readonly<IEmployee> = {};
